var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SubjectStatusTotals } from '../../SubjectOverviewNew';
let SubjectGoalIcons = class SubjectGoalIcons extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    subjectGoalIconClass(key) {
        return `subject-goal__status-icon--${key}`;
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onClick(total) {
        this.$emit('clickTotal', total);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof SubjectStatusTotals !== "undefined" && SubjectStatusTotals) === "function" ? _a : Object)
], SubjectGoalIcons.prototype, "totals", void 0);
SubjectGoalIcons = __decorate([
    Component({})
], SubjectGoalIcons);
export default SubjectGoalIcons;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
